import Vue from "vue";
import mantainanceMixin from "@/mixins/mantainanceMixin";
export default Vue.extend({
    mixins: [mantainanceMixin],
    props: {
        templateConfig: {}
    },
});
